module.exports = __webpack_public_path__ + "assets/img/featured-5.0b74a021.jpg";